import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import { Markup } from "interweave";
import WOW from "wowjs";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import parallax from "../../images/about/vision-mission-2560.jpg";

import "react-quill/dist/quill.snow.css";
import banner1 from "../../images/about/about-us-banner-2560.jpg";
import mbanner1 from "../../images/about/about-us-banner-640.jpg";
import aboutSecimg from "../../images/about/aboutSec2.png";
import visionIcon from "../../images/about/visionIcon.svg";
import missionIcon from "../../images/about/missionIcon.svg";
// import teamperson1 from "../../images/about/neil-soni.png";
import teamperson1 from "../../images/about/1778849999103Neil-Soni.png";
// import teamperson2 from "../../images/about/amrapali-soni.png";
import teamperson2 from "../../images/about/1778850220228Amrapali-Soni.png";
// import teamperson3 from "../../images/about/mitesh-jain.png";
import teamperson3 from "../../images/about/1778850451612Sai-S-Krishnan.png";
// import teamperson4 from "../../images/about/sundeep-lamba.png";
import teamperson4 from "../../images/about/1778850404128Sundeep-Lamba.png";
// import teamperson5 from "../../images/about/shashikant-jina.png";
import teamperson5 from "../../images/about/1778850300109Harish-Kumar.png";
// import teamperson6 from "../../images/about/suhasinee-patil.png";
import teamperson6 from "../../images/about/1778850123328Suhasinee-Patil.png";
// import teamperson7 from "../../images/about/rohina-ahmadi.png";
import teamperson7 from "../../images/about/1778850915826Shailesh-Venkatraman.png";
import teamperson8 from "../../images/about/1778850887646Rani.png";

import BannerItem from "../../component/BannerItem/BannerItem";
import OurTeamSlide from "../../component/OurTeamSlide/OurTeamSlide";
import useWindowDimensions from "../../useWindowDimensions";

import axios from "axios";
import urldata from "../../urldata";
import loadergif from "../../images/loader.gif";
import Imageurldata from "../../Imageurldata";

import "./style.less";
import config from "../../config/config";

const ourTeamArr = [
  {
    img: teamperson1,
    name: "Neil G. Soni",
    designation: "Chief Executive Officer",
    desc: "Neil G. Soni is President and Chairman of the Board of HOS Global Foods (India). In this role, he leverages the company’s resources to achieve the highest level of consumer satisfaction for a range of portfolio food products. Neil spearheads strategies to drive HOS growth.",
  },
  {
    img: teamperson2,
    name: "Amrapali Soni",
    designation: "Chief Operating Officer",
    desc: "Amrapali Soni is active in product and business development, technical innovation, overhead minimization, rebranding, and marketing initiatives. She keeps up with cutting-edge food and packaging trends by attending leading industry trade shows.",
  },
  {
    img: teamperson7,
    name: "Sailesh Venkatraman",
    designation: "Chief Financial Officer",
    desc: "Sailesh has extensive finance leadership experience in the food manufacturing and distribution industries, having held roles at Sara Lee Corporation, Kellogg’s, and Pinnacle Foods. Most recently, he served as CFO at Joseph’s Gourmet Pasta Company and Reldan Metals, where he led financial planning, reporting, audits, and organizational transformation.",
  },
  {
    img: teamperson4,
    name: "Sundeep Lamba",
    designation: "Chief Of Sales",
    desc: "Sundeep Singh Lamba is a successful leader with 27 years of experience. His achievements span Sales and Marketing functions, the development of Distribution Networks and Sales Teams, as well as achieving high market share in a competitive space. Her specializes in Brand Building.",
  },
  {
    img: teamperson3,
    name: "Sai S. Krishnan",
    designation: "VP of Operations",
    desc: "Sai has over 25 years of global experience in Supply Chain and Operations Management in the food and consumer goods sector. He has successfully led end-to-end supply chain optimization initiatives across organizations such as Nissan Foods, Olam Food Ingredients, and LT Foods driving significant gains in efficiency, cost reduction, and profitability.",
  },
  {
    img: teamperson5,
    name: "Harish Kumar",
    designation: "VP of Supply Chain",
    desc: "Harish leads the entire supply chain ecosystem and drives the SCM Strategy framework for HOS. He holds and MBA in Supply Chain and has 17 years of experience in India, Africa, and the US.",
  },
  {
    img: teamperson6,
    name: "Suhasinee Patil",
    designation: "VP of Marketing",
    desc: "Suhasinee is a Marketing professional with over 25 years' experience in International Business. She has worked closely with various leading Indian food brands and handled North America, UK and Middle East markets. Over the last decade she has specialized in Multicultural Marketing in North America specific to South Asian and Middle Eastern diaspora.",
  },
  {
    img: teamperson8,
    name: "Rani Choura",
    designation: "VP of IT",
    desc: "Rani serves as the Vice President of Information Technology at House of Spices Global Foods, where he leads the IT department and oversees the company’s technology infrastructure. He focuses on cloud computing, ERP systems, and data analytics to ensure efficient IT operations and support business growth.",
  },
];

const About = (props) => {
  const { height, width } = useWindowDimensions();

  const [loading, setLoading] = useState(true);
  const [aboutBanner, setaboutBanner] = useState([]);
  const [aboutsection2, setaboutsection2] = useState([]);
  const [aboutsection3, setaboutsection3] = useState([]);
  const [aboutsection4, setaboutsection4] = useState([]);

  // getAboutusData

  useEffect(() => {
    window.scroll(0, 0);

    let url = new URL(urldata + "user/getAboutusData");

    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        // console.log(response.data.data);

        const aboutdata = response.data.data;
        setaboutBanner(aboutdata.bannerData);
        setaboutsection2(aboutdata.aboutussecTwo);
        setaboutsection3(aboutdata.aboutussecThree);
        // setaboutsection4(aboutdata.aboutussecFour);
        setaboutsection4(ourTeamArr);
        setLoading(false);
      })
      .catch((error) => {
        alert("Something Went Wrong");
      });

    document.title =
      "About Us - Largest South Asian food distributors with 11 warehouses";
    document.getElementsByTagName("META")[3].content =
      "With over 48 years of experience in the market, HOS Global Foods is the most popular choice for quality South Asian flavours in the USA.";
    document.getElementsByTagName("META")[4].content =
      "South Asian flavours, ethnic food, Indian Spices";

    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  if (loading) {
    return (
      <div className="loadergifdiv">
        <img src={loadergif} className="img-fluid" />
      </div>
    );
  }

  return (
    <>
      <main className="main_container">
        <section className="aboutsec1 wow fadeIn">
          <BannerItem
            img={Imageurldata + aboutBanner[0].imgUrl}
            imgMb={Imageurldata + aboutBanner[0].mbimgUrl}
            title={aboutBanner[0].title}
            desc={aboutBanner[0].text1}
          />
        </section>
        <section className="aboutsec2 wow fadeIn">
          <Row className="row m-0 a-c">
            <Col lg={5}>
              <img
                className="img-fluid"
                src={Imageurldata + aboutsection2[0].img}
              />
            </Col>
            <Col lg={7} style={{ paddingBottom: "20px" }}>
              {/* <p> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: aboutsection2[0].desc.replace(
                    /(<? *script)/gi,
                    "illegalscript",
                  ),
                }}
              ></div>
              {/* </p> */}
            </Col>
          </Row>
        </section>
        <section className="aboutsec3 wow fadeIn">
          <div className="aboutsec3bg">
            <div
              style={{
                backgroundImage: `url(${Imageurldata + aboutsection3[0].img1})`,
              }}
              className="parallaxContainer"
            >
              <div className="visionMissionCards">
                <div className="visionMissionCard wow slideInLeft">
                  <div className="icon">
                    <img
                      className="img-fluid"
                      src={Imageurldata + aboutsection3[0].img2}
                    />
                  </div>
                  <div className="title">{aboutsection3[0].imgtitle2}</div>
                  <div className="desc">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: aboutsection3[0].descimg2.replace(
                          /(<? *script)/gi,
                          "illegalscript",
                        ),
                      }}
                    ></div>
                  </div>
                </div>
                <div className="visionMissionCard wow slideInRight">
                  <div className="icon">
                    <img
                      className="img-fluid"
                      src={Imageurldata + aboutsection3[0].img3}
                    />
                  </div>
                  <div className="title">{aboutsection3[0].imgtitle3}</div>
                  <div className="desc">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: aboutsection3[0].descimg3.replace(
                          /(<? *script)/gi,
                          "illegalscript",
                        ),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="aboutsec4 wow fadeIn">
          <div className="title">OUR TEAM</div>
          <OurTeamSlide
            aboutsection4={aboutsection4}
            image_url={Imageurldata}
          />
        </section>
      </main>
    </>
  );
};

export default About;
